const isBrowser = () => typeof window !== 'undefined';
export const auth0Domain =
  (isBrowser() && ((window as any).REACT_APP_AUTH0_DOMAIN as string)) || '';
export const auth0CmsClientId =
  (isBrowser() && ((window as any).REACT_APP_AUTH0_CMS_CLIENT_ID as string)) || '';
